/* eslint-disable import/prefer-default-export */

import { PersonalFinanceActionCreators, PersonalFinanceActionTypes } from './types';

const getLocalStorageItem = (key: string): number => parseFloat(localStorage.getItem(key)) || 0;
const setLocalStorageItem = (key: string, value: number): void => localStorage.setItem(key, value.toString());

export const userPersonalFinanceSuccess = (personalFinance): PersonalFinanceActionCreators => {
  return { type: PersonalFinanceActionTypes.PERSONAL_FINANCE_SUCCESS, personalFinance };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const doFetchPersonalFinance = () => {
  return async (dispatch): Promise<void> => {
    try {
      // Fetch from localstorage here.
      let personalFinance = {
        salary: null,
        otherPayments: null,
        otherInsurance: null,
        saving: null,
      };
      if (process.browser) {
        personalFinance = {
          salary: getLocalStorageItem('salary') || null,
          otherPayments: getLocalStorageItem('otherPayments') || null,
          otherInsurance: getLocalStorageItem('otherInsurance') || null,
          saving: getLocalStorageItem('saving') || null,
        };
      }
      dispatch(userPersonalFinanceSuccess(personalFinance));
    } catch (err) {
      console.log('err', err);
    }
  };
};

const updatePersonalFinance = (field, value): PersonalFinanceActionCreators => {
  return {
    type: PersonalFinanceActionTypes.PERSONAL_FINANCE_UPDATE,
    field,
    value: parseFloat(value),
  };
};

export const doUpdatePersonalFinance = (field, value) => {
  return async (dispatch): Promise<void> => {
    try {
      setLocalStorageItem(field, value);
      dispatch(updatePersonalFinance(field, value));
    } catch (err) {
      console.log('err', err);
    }
  };
};
